import React, { useState } from "react";

import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

const warningMessage = `If you delete it, attachment deletion according to this setting will be stopped.`;
function DeleteAttachmentModal(props) {
  const { service, handleRevokeService } = props;
  const [revokeOpen, setRevokeOpen] = useState(false);

  const handleClickRevokeOpen = () => {
    setRevokeOpen(true);
  };

  const handleRevokeClose = () => {
    setRevokeOpen(false);
  };

  return (
    <>
      <Button variant="contained" color="error" onClick={handleClickRevokeOpen}>
        Delete
      </Button>
      <Dialog
        open={revokeOpen}
        onClose={handleRevokeClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {`Do you want to delete `}
          <strong>{service?.name}</strong>
          {` attachment delete setting?`}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {warningMessage}
            <br />

            {`Custom View: `}
            <strong>
              {service?.sheduleDeleteViewAttachment?.displayLabel}
            </strong>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleRevokeClose}
            autoFocus
            variant="contained"
            color="success"
          >
            Dont delete
          </Button>
          <Button
            onClick={handleRevokeService}
            variant="outlined"
            color="error"
          >
            I want to delete {service?.name}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default DeleteAttachmentModal;
